import {
  toLakh,
  sumThis,
  numberWithCommas,
  toCurrency,
  sumOf,
  countOf,
  sumAndCountOf,
  showSum,
  showCount,
  showSumAndCount,
  percentChange,
  showBlank,
  changeClassTo,
  mobileNumber,
  panCardNumber,
  validEmail,
  adharNumber,
  allDirectQueries
} from "../../commonFunctions";
import { controls } from "../../controls";

const pr000 = {
  label: "Parameters",
  pageLabel: "Parameters",
  starting: true,
  url: "pr000",
  pageType: "history",
  formTabs: {
    allTabs: [
      { label: "Product", uid: "product", style: { fontFamily: "verdana" } },
      { label: "General", uid: "general", style: { fontFamily: "verdana" } },
      { label: "Clearing", uid: "clearing", style: { fontFamily: "verdana" } },
      { label: "TDS", uid: "tds", style: { fontFamily: "verdana" } },
      { label: "Loan", uid: "loan", style: { fontFamily: "verdana" } },
      { label: "Cheque", uid: "cheque", style: { fontFamily: "verdana" } },
      { label: "DD Information", uid: "ddInfo", style: { fontFamily: "verdana" } },
      { label: "PayRoll", uid: "payroll", style: { fontFamily: "verdana" } },
      { label: "Vouchers", uid: "vouchers", style: { fontFamily: "verdana" } },
      { label: "Shares", uid: "shares", style: { fontFamily: "verdana" } },
      { label: "APB ACH ECB", uid: "apbachecb", style: { fontFamily: "verdana" } },
      { label: "Stock", uid: "stock", style: { fontFamily: "verdana" } },
      { label: "BeginDay", uid: "beginDay", style: { fontFamily: "verdana" } },
    ]
  },

  form: [
    {
      inputType: "displaytext",
      tab: "product",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "HO Branch",
      name: "",
      description: "Enter HO Branch"
    },
    {
      inputType: "text",
      tab: "product",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "HO Branch",
      name: "HOBranch",
      description: "Enter HO Branch"
    },
    {
      inputType: "displaytext",
      tab: "product",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Society Account Type",
      name: "",
      description: "Enter Society Account Type"
    },
    {
      inputType: "autocomplete",
      tab: "product",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Society Account Type",
      name: "Society_Account_Type",
      description: "Society Account Type"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      // default: "false",
      tab: "product",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Process NEFT InwardReturn Automatically",
      name: "Process_NEFT_InwardReturn_Automatically",
      description: "Process NEFT InwardReturn Automatically"
    },
    {
      inputType: "displaytext",
      tab: "product",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "No Of Records",
      name: "",
      description: "Enter No Of Records"
    },
    {
      inputType: "text",
      tab: "product",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "No Of Records",
      name: "No_Of_Records",
      description: "Enter No Of Records"
    },
    {
      inputType: "displaytext",
      tab: "product",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Co-op Society Account Type",
      name: "",
      description: "Enter Co-op Society Account Type"
    },
    {
      inputType: "autocomplete",
      tab: "product",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Co-op Society Account Type",
      name: "Coop_Society_Account_Type",
      description: "Co-op Society Account Type"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "",
      tab: "product",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Print Renewed FD Receipt",
      name: "Print_RenewedFDReceipt",
      description: "Print Renewed FD Receipt"
    },
    {
      inputType: "displaytext",
      tab: "product",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Password Expired in Days",
      name: "",
      description: "Password Expired in Days"
    },
    {
      inputType: "text",
      tab: "product",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Password Expired in Days",
      name: "Password_Expired_in_Days",
      description: "Enter Password Expired in Days"
    },
    {
      inputType: "displaytext",
      tab: "product",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Co-op Bank Account Type",
      name: "",
      description: "Enter Co-op Bank Account Type"
    },
    {
      inputType: "autocomplete",
      tab: "product",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Co-op Bank Account Type",
      name: "Coop_Bank_Account_Type",
      description: "Co-op Bank Account Type"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "",
      tab: "product",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Employee Code Numeric",
      name: "Employee_Code_Numeric",
      description: "Employee Code Numeric"
    },
    {
      inputType: "displaytext",
      tab: "product",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Individual Account Type",
      name: "",
      description: "Enter Individual Account Type"
    },

    ...controls.autoComplete({
      tab: "product", name: "ac_type", width: "col-sm-4", placeHolder: "Autocomplete",
      defaultValue: "",
      options: [{
        label: "Normal",
        value: "Normal"
      }, {
        label: "display",
        value: "display"
      }
      ]
    }),


    {
      inputType: "checkbox",
      isRequired: true,
      default: "",
      tab: "product",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "GL Code Numeric",
      name: "GL_Code_Numeric",
      description: "GL Code Numeric"
    },
    {
      inputType: "displaytext",
      tab: "product",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Self Mode Of Operation",
      name: "",
      description: "Self Mode Of Operation"
    },
    {
      inputType: "autocomplete",
      tab: "product",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Self Mode Of Operation",
      name: "Self_Mode_Of_Operation",
      description: "Self Mode Of Operation"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "",
      tab: "product",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Product Code Numeric",
      name: "Product_Code_Numeric",
      description: "Product Code Numeric"
    },
    {
      inputType: "displaytext",
      tab: "product",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Builder Occupation",
      name: "",
      description: "Builder Occupation"
    },
    {
      inputType: "autocomplete",
      tab: "product",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Builder Occupation",
      name: "Builder_Occupation",
      description: "Builder Occupation"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "",
      tab: "product",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Display IN Marathi",
      name: "Display_IN_Marathi",
      description: "Display IN Marathi"
    },
    {
      inputType: "displaytext",
      tab: "product",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Politician Occupation",
      name: "",
      description: "Politician Occupation"
    },
    {
      inputType: "autocomplete",
      tab: "product",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Politician Occupation",
      name: "Politician_Occupation",
      description: "Politician Occupation"
    },

    {
      inputType: "displaytext",
      tab: "general",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Cash IN Hand GL",
      name: "",
      description: "Cash IN Hand GL"
    },
    {
      inputType: "autocomplete",
      tab: "general",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Cash IN Hand GL",
      name: "Cash_IN_Hand_GL",
      description: "Cash IN Hand GL"
    },
    {
      inputType: "displaytext",
      tab: "general",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "ATM Cash GL",
      name: "",
      description: "ATM Cash GL"
    },
    {
      inputType: "autocomplete",
      tab: "general",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "ATM Cash GL",
      name: "ATM_Cash_GL",
      description: "ATM Cash GL"
    },
    {
      inputType: "displaytext",
      tab: "general",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "ATM RC GL",
      name: "",
      description: "ATM RC GL"
    },
    {
      inputType: "autocomplete",
      tab: "general",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "ATM RC GL",
      name: "ATM_RC_GL",
      description: "ATM RC GL"
    },
    {
      inputType: "displaytext",
      tab: "general",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "ATM Fees GL",
      name: "",
      description: "ATM Fees GL"
    },
    {
      inputType: "autocomplete",
      tab: "general",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "ATM Fees GL",
      name: "ATM_Fees_GL",
      description: "ATM Fees GL"
    },
    {
      inputType: "displaytext",
      tab: "general",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Profit GL",
      name: "",
      description: "Profit GL"
    },
    {
      inputType: "autocomplete",
      tab: "general",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Profit GL",
      name: "Profit_GL",
      description: "Profit GL"
    },
    {
      inputType: "displaytext",
      tab: "general",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Branch Adjustment GL",
      name: "",
      description: "Branch Adjustment GL"
    },
    {
      inputType: "autocomplete",
      tab: "general",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Branch Adjustment GL",
      name: "Branch_Adjustment_GL",
      description: "Branch Adjustment GL"
    },
    {
      inputType: "displaytext",
      tab: "general",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Branch Adjustment Product",
      name: "",
      description: "Branch Adjustment Product"
    },
    {
      inputType: "autocomplete",
      tab: "general",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Branch Adjustment Product",
      name: "Branch_Adjustment_Product",
      description: "Branch Adjustment Product"
    },
    {
      inputType: "displaytext",
      tab: "general",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "BC GL",
      name: "",
      description: "BC GL"
    },
    {
      inputType: "autocomplete",
      tab: "general",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "BC GL",
      name: "BC_GL",
      description: "BC GL"
    },
    {
      inputType: "displaytext",
      tab: "general",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "BR GL",
      name: "",
      description: "BR GL"
    },
    {
      inputType: "autocomplete",
      tab: "general",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "BR GL",
      name: "BR_GL",
      description: "BR GL"
    },
    {
      inputType: "displaytext",
      tab: "general",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "BC Payable GL(sent To)",
      name: "",
      description: "BC Payable GL"
    },
    {
      inputType: "autocomplete",
      tab: "general",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "BC Payable GL",
      name: "BC_PayableGL",
      description: "BC Payable GL"
    },
    {
      inputType: "displaytext",
      tab: "general",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Postage Recd GL",
      name: "",
      description: "Postage Recd GL"
    },
    {
      inputType: "autocomplete",
      tab: "general",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Postage Recd GL",
      name: "PostageRecd_GL",
      description: "Postage Recd GL"
    },
    {
      inputType: "displaytext",
      tab: "general",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Surcharge GL",
      name: "",
      description: "Surcharge GL"
    },
    {
      inputType: "autocomplete",
      tab: "general",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Surcharge GL",
      name: "Surcharge_GL",
      description: "Surcharge GL"
    },
    {
      inputType: "displaytext",
      tab: "general",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "SMS Charges Received GL",
      name: "",
      description: "SMS Charges Received GL"
    },
    {
      inputType: "autocomplete",
      tab: "general",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "SMS Charges Received GL",
      name: "SMSChargesReceived_GL",
      description: "SMS Charges Received GL"
    },
    {
      inputType: "displaytext",
      tab: "general",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "SMS Service Tax Recd GL",
      name: "",
      description: "SMS Service Tax Recd  GL"
    },
    {
      inputType: "autocomplete",
      tab: "general",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "SMS Service Tax Recd  GL",
      name: "SMS_ServiceTaxRecd _GL",
      description: "SMS Service Tax Recd GL"
    },
    {
      inputType: "displaytext",
      tab: "general",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Saving Product",
      name: "",
      description: "Saving Product"
    },
    {
      inputType: "autocomplete",
      tab: "general",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Saving Product",
      name: "Saving_ProductL",
      description: "Saving Product"
    },
    {
      inputType: "displaytext",
      tab: "general",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Closing Charges Received",
      name: "",
      description: "Closing Charges Received"
    },
    {
      inputType: "autocomplete",
      tab: "general",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Closing Charges Received",
      name: "Closing_ChargesReceived",
      description: "Closing Charges Received"
    },
    {
      inputType: "displaytext",
      tab: "general",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Closing Service Tax Recd GL",
      name: "",
      description: "Closing Service Tax Recd GL"
    },
    {
      inputType: "autocomplete",
      tab: "general",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Closing Service Tax Recd GL",
      name: "Closing_ServiceTaxRecdGL",
      description: "Closing Service Tax Recd GL"
    },
    {
      inputType: "displaytext",
      tab: "general",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Service Tax Rate",
      name: "",
      description: "Service Tax Rate"
    },
    {
      inputType: "text",
      tab: "general",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Service Tax Rate",
      name: "Service_Tax_Rate",
      description: "Service Tax Rate"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "",
      tab: "clearing",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Centrlaised Clearing",
      name: "Centrlaised_Clearing",
      description: "Centrlaised Clearing"
    },

    {
      inputType: "checkbox",
      isRequired: true,
      default: "",
      tab: "clearing",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Create Branchwise Inward Clearing Total While Copying CTS Clearing",
      name: "CreateBranchwiseInward_ClearingTotalWhileCopyingCTS_Clearing",
      description: "Create Branchwise Inward Clearing Total While Copying CTS Clearing"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "",
      tab: "clearing",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Local Credit Clearing",
      name: "Local_Credit_Clearing",
      description: "Local Credit Clearing"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "",
      tab: "clearing",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Loan Credits Intermediate Account",
      name: "LoanCreditsIntermediate_Account",
      description: "Loan Credits Intermediate Account"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "",
      tab: "clearing",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Outward(credit)return Charges Applicable",
      name: "Outward_return_ChargesApplicable",
      description: "Outward(credit)return Charges Applicable"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "",
      tab: "clearing",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Inward(debit)return Charges Applicable",
      name: "Inward_return_Charges_Applicable",
      description: "Inward(debit)return Charges Applicable"
    },
    {
      inputType: "displaytext",
      tab: "clearing",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Clearing House GL",
      name: "",
      description: "Clearing House GL"
    },
    {
      inputType: "autocomplete",
      tab: "clearing",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Clearing House GL",
      name: "Clearing_HouseGL",
      description: "Clearing House GL"
    },
    {
      inputType: "displaytext",
      tab: "clearing",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Clearing House Adjustment",
      name: "",
      description: "Clearing House Adjustment"
    },
    {
      inputType: "autocomplete",
      tab: "clearing",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Clearing House Adjustment",
      name: "Clearing_HouseAdjustment",
      description: "Clearing House Adjustment"
    },
    {
      inputType: "displaytext",
      tab: "clearing",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Clearing House AcctCode",
      name: "",
      description: "Clearing House AcctCode"
    },
    {
      inputType: "autocomplete",
      tab: "clearing",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Clearing House AcctCode",
      name: "Clearing_HouseAcctCode",
      description: "Clearing House AcctCode"
    },
    {
      inputType: "displaytext",
      tab: "clearing",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Clearing House Adj AcctCode",
      name: "",
      description: "Clearing House Adj AcctCode"
    },
    {
      inputType: "autocomplete",
      tab: "clearing",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Clearing House Adj AcctCode",
      name: "Clearing_HouseAdjAcctCode",
      description: "Clearing House Adj AcctCode"
    },
    {
      inputType: "displaytext",
      tab: "clearing",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "CGST GL",
      name: "",
      description: "CGST GL"
    },
    {
      inputType: "autocomplete",
      tab: "clearing",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "CGST GL",
      name: "CGST_GL",
      description: "CGST GL"
    },
    {
      inputType: "displaytext",
      tab: "clearing",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "SGST GL",
      name: "",
      description: "SGST GL"
    },
    {
      inputType: "autocomplete",
      tab: "clearing",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "SGST GL",
      name: "SGST_GL",
      description: "SGST GL"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      // default: "false",
      tab: "tds",
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Auto TDS Setting",
      name: "Auto_TDS_Setting",
      description: "Auto TDS Setting"
    },
    {
      inputType: "displaytext",
      tab: "tds",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "TDS Rate",
      name: "",
      description: "Enter TDS Rate"
    },
    {
      inputType: "text",
      tab: "tds",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "TDS Rate",
      name: "TDSRate",
      description: "Enter TDS Rate"
    },
    {
      inputType: "displaytext",
      tab: "tds",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "TDS Rate For No PAN",
      name: "",
      description: "Enter TDS Rate For No PAN"
    },
    {
      inputType: "text",
      tab: "tds",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "TDS Rate For No PAN",
      name: "TDSRateForNoPAN",
      description: "Enter TDS Rate For No PAN"
    },
    {
      inputType: "displaytext",
      tab: "tds",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Surchrage Rate",
      name: "",
      description: "Enter Surchrage Rate"
    },
    {
      inputType: "text",
      tab: "tds",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Surchrage Rate",
      name: "SurchrageRate",
      description: "Enter Surchrage Rate"
    },
    {
      inputType: "displaytext",
      tab: "tds",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Surchrage Rate no PAN",
      name: "",
      description: "Enter Surchrage Rate no PAN"
    },
    {
      inputType: "text",
      tab: "tds",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Surchrage Rate no PAN",
      name: "SurchrageRatenoPAN",
      description: "Enter Surchrage Rate no PAN"
    },
    {
      inputType: "displaytext",
      tab: "tds",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Cess Rate",
      name: "",
      description: "Enter Cess Rate"
    },
    {
      inputType: "text",
      tab: "tds",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Cess Rate",
      name: "CessRate",
      description: "Enter Cess Rate"
    },
    {
      inputType: "displaytext",
      tab: "tds",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Cess Rate No PAN",
      name: "",
      description: "Enter Cess Rate No PAN"
    },
    {
      inputType: "text",
      tab: "tds",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Cess Rate No PAN",
      name: "CessRateNo_PAN",
      description: "Enter Cess Rate No PAN"
    },
    {
      inputType: "displaytext",
      tab: "tds",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "TDS Payable GL",
      name: "",
      description: "TDS Payable GL"
    },
    {
      inputType: "autocomplete",
      tab: "tds",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "TDS Payable GL",
      name: "TDSPayableGL",
      description: "TDS Payable GL"
    },
    {
      inputType: "displaytext",
      tab: "tds",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Surcharge Payable GL",
      name: "",
      description: "Surcharge Payable GL"
    },
    {
      inputType: "autocomplete",
      tab: "tds",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Surcharge Payable GL",
      name: "SurchargePayableGL",
      description: "Surcharge Payable GL"
    },
    {
      inputType: "displaytext",
      tab: "tds",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Cess Payable GL",
      name: "",
      description: "Cess Payable GL"
    },
    {
      inputType: "autocomplete",
      tab: "tds",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Cess Payable GL",
      name: "CessPayableGL",
      description: "Cess Payable GL"
    },
    {
      inputType: "displaytext",
      tab: "loan",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Gold Insurance GL",
      name: "",
      description: "Gold Insurance GL"
    },
    {
      inputType: "autocomplete",
      tab: "loan",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Gold Insurance GL",
      name: "GoldInsuranceGL",
      description: "Gold Insurance GL"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "",
      tab: "loan",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Penal Column",
      name: "PenalColumn",
      description: "Penal Column"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "",
      tab: "loan",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Postage Column",
      name: "PostageColumn",
      description: "Postage Column"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "",
      tab: "loan",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Notice Fees Column",
      name: "NoticeFeesColumn",
      description: "Notice Fees Column"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "",
      tab: "loan",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Court Exps Column",
      name: "CourtExps_Column",
      description: "Court Exps Column"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "",
      tab: "loan",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Insurance Column",
      name: "InsuranceColumn",
      description: "Insurance Column"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "",
      tab: "loan",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Surcharge Column",
      name: "SurchargeColumn",
      description: "Surcharge Column"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "",
      tab: "loan",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Other Exp Column",
      name: "OtherExpColumn",
      description: "Other Exp Column"
    },
    {
      inputType: "displaytext",
      tab: "cheque",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Cheque Book Charges GL",
      name: "",
      description: "Cheque Book Charges GL"
    },
    {
      inputType: "autocomplete",
      tab: "cheque",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Cheque Book Charges GL",
      name: "ChequeBookChargesGL",
      description: "Cheque Book Charges GL"
    },
    {
      inputType: "displaytext",
      tab: "cheque",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Valid For Months and Days",
      name: "",
      description: "Enter Valid For Months and Days"
    },
    {
      inputType: "date",
      dateType: "ontype",
      tab: "cheque",
      isRequired: true,
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "DOB",
      displayFormat: "DD/MM/YYYY",
      outputFormat: "YYYYMMDD",
      name: "ValidForMonthsandDays",
      description: "Enter Valid For Months and Days"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "",
      tab: "cheque",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Cheque-NoProduct-Typewise",
      name: "Cheque_NoProduct_Typewise",
      description: "Cheque-NoProduct-Typewise"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "",
      tab: "cheque",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Cheque PersonolisedFacility",
      name: "Cheque_PersonolisedFacility",
      description: "Cheque PersonolisedFacility"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "",
      tab: "cheque",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Cheque Charges Per Leaf",
      name: "Cheque_ChargesPerLeaf",
      description: "Cheque Charges Per Leaf"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "",
      tab: "cheque",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Cheque Charges Productwise",
      name: "Cheque_ChargesProductwise",
      description: "Cheque Charges Productwise"
    },
    {
      inputType: "displaytext",
      tab: "ddInfo",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "DD Payable GL",
      name: "",
      description: "DD Payable GL"
    },
    {
      inputType: "autocomplete",
      tab: "ddInfo",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "DD Payable GL",
      name: "DDPayableGL",
      description: "DD Payable GL"
    },
    {
      inputType: "displaytext",
      tab: "ddInfo",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Our Commission GL",
      name: "",
      description: "Our Commission GL"
    },
    {
      inputType: "autocomplete",
      tab: "ddInfo",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Our Commission GL",
      name: "OurCommissionGL",
      description: "Our Commission GL"
    },
    {
      inputType: "displaytext",
      tab: "ddInfo",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Their Commission GL",
      name: "",
      description: "Their CommissionGL"
    },
    {
      inputType: "autocomplete",
      tab: "ddInfo",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Their Commission GL",
      name: "TheirCommissionGL",
      description: "Their Commission GL"
    },
    {
      inputType: "displaytext",
      tab: "ddInfo",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Service Tax GL",
      name: "",
      description: "Service Tax GL"
    },
    {
      inputType: "autocomplete",
      tab: "ddInfo",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Service Tax GL",
      name: "ServiceTaxGL",
      description: "Service Tax GL"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "",
      tab: "ddInfo",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "DD Commission Editable",
      name: "DDCommissionEditable",
      description: "DD Commission Editable"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "",
      tab: "payroll",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Want Expenses Branchwise",
      name: "WantExpensesBranchwise",
      description: "Want Expenses Branchwise"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "",
      tab: "payroll",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Pay Posting Employee Wise",
      name: "PayPostingEmployeeWise",
      description: "Pay Posting Employee Wise"
    },
    {
      inputType: "displaytext",
      tab: "payroll",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Basic Debit To GL",
      name: "",
      description: "Basic Debit To GL"
    },
    {
      inputType: "autocomplete",
      tab: "payroll",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Basic Debit To GL",
      name: "BasicDebitToGL",
      description: "Basic Debit To GL"
    },
    {
      inputType: "displaytext",
      tab: "payroll",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Priviledge Leave",
      name: "",
      description: "Priviledge Leave"
    },
    {
      inputType: "autocomplete",
      tab: "payroll",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Priviledge Leave",
      name: "PriviledgeLeave",
      description: "Priviledge Leave"
    },
    {
      inputType: "displaytext",
      tab: "payroll",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Medical Leave",
      name: "",
      description: "Medical Leave"
    },
    {
      inputType: "autocomplete",
      tab: "payroll",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Medical Leave",
      name: "MedicalLeave",
      description: "Medical Leave"
    },
    {
      inputType: "displaytext",
      tab: "payroll",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Maximum Deduction Percent In Pay",
      name: "",
      description: "Enter Maximum Deduction Percent In Pay"
    },
    {
      inputType: "text",
      tab: "payroll",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Maximum Deduction Percent In Pay",
      name: "MaximumDeductionPercentIn_Pay"
    },
    {
      inputType: "displaytext",
      tab: "vouchers",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Credit Cash Particulars",
      name: "",
      description: "Enter Credit Cash Particulars"
    },
    {
      inputType: "text",
      tab: "vouchers",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Credit Cash Particulars",
      name: "CreditCashParticulars"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "",
      tab: "vouchers",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Cash Receipt Voucher Print",
      name: "CashReceiptVoucherPrint",
      description: "Cash Receipt Voucher Print"
    },
    {
      inputType: "displaytext",
      tab: "vouchers",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Debit Cash Particulars",
      name: "",
      description: "Enter Debit Cash Particulars"
    },
    {
      inputType: "text",
      tab: "vouchers",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Debit Cash Particulars",
      name: "DebitCashParticulars"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "",
      tab: "vouchers",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Cash Payment Voucher Print",
      name: "CashPaymentVoucherPrint",
      description: "Cash Payment Voucher Print"
    },
    {
      inputType: "displaytext",
      tab: "vouchers",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Credit Transfer Particulars",
      name: "",
      description: "Enter Credit Transfer Particulars"
    },
    {
      inputType: "text",
      tab: "vouchers",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Credit Transfer Particulars",
      name: "CreditTransferParticulars"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "",
      tab: "vouchers",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Transfer Voucher Print",
      name: "TransferVoucherPrint",
      description: "Transfer Voucher Print"
    },
    {
      inputType: "displaytext",
      tab: "vouchers",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Debit Transfer Particulars",
      name: "",
      description: "Enter Debit Transfer Particulars"
    },
    {
      inputType: "text",
      tab: "vouchers",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Debit Transfer Particulars",
      name: "DebitTransferParticulars"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "",
      tab: "vouchers",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Clr Debit Voucher Print",
      name: "ClrDebitVoucherPrint",
      description: "Clr Debit Voucher Print"
    },
    {
      inputType: "displaytext",
      tab: "vouchers",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Credit Clearing Particulars",
      name: "",
      description: "Enter Credit Clearing Particulars"
    },
    {
      inputType: "text",
      tab: "vouchers",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Credit Clearing Particulars",
      name: "CreditClearingParticulars"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "",
      tab: "vouchers",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Clr Credit Voucher Print",
      name: "ClrCreditVoucherPrint",
      description: "Clr Credit Voucher Print"
    },
    {
      inputType: "displaytext",
      tab: "vouchers",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Debit Clearing Particulars",
      name: "",
      description: "Enter Debit Clearing Particulars"
    },
    {
      inputType: "text",
      tab: "vouchers",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Debit Clearing Particulars",
      name: "DebitClearingParticulars"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "",
      tab: "vouchers",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Cash Reception Counter",
      name: "CashReception_Counter",
      description: "Cash Reception Counter"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "",
      tab: "vouchers",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Branchwise Voucher Numbers",
      name: "BranchwiseVoucherNumbers",
      description: "Branchwise Voucher Numbers"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "",
      tab: "vouchers",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Continue Particular for Next Transaction",
      name: "ContinueParticularfor_NextTransaction",
      description: "Continue Particular for Next Transaction"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "",
      tab: "vouchers",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Token Required",
      name: "Token_Required",
      description: "Token Required"
    },
    {
      inputType: "displaytext",
      tab: "shares",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Share GL",
      name: "",
      description: "Share GL"
    },
    {
      inputType: "autocomplete",
      tab: "shares",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Share GL",
      name: "Share_GL",
      description: "Share GL"
    },
    {
      inputType: "displaytext",
      tab: "shares",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Share Suspense GL",
      name: "",
      description: "Share Suspense GL"
    },
    {
      inputType: "autocomplete",
      tab: "shares",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Share Suspense GL",
      name: "ShareSuspense_GL",
      description: "Share Suspense GL"
    },
    {
      inputType: "displaytext",
      tab: "shares",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Associated Share Suspense",
      name: "",
      description: "Associated Share Suspense"
    },
    {
      inputType: "autocomplete",
      tab: "shares",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Associated Share Suspense",
      name: "AssociatedShare_Suspense",
      description: "Associated Share Suspense"
    },
    {
      inputType: "displaytext",
      tab: "shares",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Dividend Payable GL",
      name: "",
      description: "Dividend Payable GL"
    },
    {
      inputType: "autocomplete",
      tab: "shares",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Dividend Payable GL",
      name: "DividendPayable_GL",
      description: "Dividend Payable GL"
    },
    {
      inputType: "displaytext",
      tab: "shares",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Dividend Calculation",
      name: "",
      description: "Dividend Calculation"
    },
    {
      inputType: "autocomplete",
      tab: "shares",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Dividend Calculation",
      name: "Dividend_Calculation",
      description: "Dividend Calculation"
    },
    {
      inputType: "displaytext",
      tab: "shares",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Regular Member No",
      name: "",
      description: "Enter Regular Member No"
    },
    {
      inputType: "text",
      tab: "shares",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Regular Member No",
      name: "RegularMember_No"
    },
    {
      inputType: "displaytext",
      tab: "shares",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Associated Member No",
      name: "",
      description: "Enter Associated Member No"
    },
    {
      inputType: "text",
      tab: "shares",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Associated Member No",
      name: "AssociatedMember_No"
    },
    {
      inputType: "displaytext",
      tab: "shares",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Nominal Member No",
      name: "",
      description: "Enter Nominal Member No"
    },
    {
      inputType: "text",
      tab: "shares",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Nominal Member No",
      name: "NominalMember_No"
    },
    {
      inputType: "displaytext",
      tab: "shares",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Maximum Certificate No",
      name: "",
      description: "Enter Maximum Certificate No"
    },
    {
      inputType: "text",
      tab: "shares",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Maximum Certificate No",
      name: "MaximumCertificate_No"
    },
    {
      inputType: "displaytext",
      tab: "shares",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Maximum Share SrNo",
      name: "",
      description: "Enter Maximum Share SrNo"
    },
    {
      inputType: "text",
      tab: "shares",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Maximum Share SrNo",
      name: "Maximum_ShareSrNo"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "",
      tab: "shares",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Calculation Dividend Resigned Members",
      name: "CalculationDividend_ResignedMembers",
      description: "Calculation Dividend Resigned Members"
    },
    {
      inputType: "displaytext",
      tab: "apbachecb",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "APBCR GI",
      name: "",
      description: "APBCR GI"
    },
    {
      inputType: "autocomplete",
      tab: "apbachecb",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "APBCR GI",
      name: "APBCR_GI",
      description: "APBCR GI"
    },
    {
      inputType: "displaytext",
      tab: "apbachecb",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "ACHOR GI",
      name: "",
      description: "ACHOR GI"
    },
    {
      inputType: "autocomplete",
      tab: "apbachecb",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "ACHOR GI",
      name: "ACHOR_GI",
      description: "ACHOR GI"
    },
    {
      inputType: "displaytext",
      tab: "apbachecb",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "ACHDR GI",
      name: "",
      description: "ACHDR GI"
    },
    {
      inputType: "autocomplete",
      tab: "apbachecb",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "ACHDR GI",
      name: "ACHDR_GI",
      description: "ACHDR GI"
    },
    {
      inputType: "displaytext",
      tab: "apbachecb",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "ECSDR GI",
      name: "",
      description: "ECSDR GI"
    },
    {
      inputType: "autocomplete",
      tab: "apbachecb",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "ECSDR GI",
      name: "ECSDR_GI",
      description: "ECSDR GI"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "",
      tab: "apbachecb",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "ECS DR Mandata Check Required",
      name: "ECSDR_MandataCheckRequired",
      description: "ECS DR Mandata Check Required"
    },
    {
      inputType: "displaytext",
      tab: "stock",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Depreciation Calculation",
      name: "",
      description: "Depreciation Calculation"
    },
    {
      inputType: "autocomplete",
      tab: "stock",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        },

      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Depreciation Calculation",
      name: "Depreciation_Calculation",
      description: "Depreciation Calculation"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "",
      tab: "stock",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Asset GL Mentained In HO",
      name: "Asset_GLMentainedInHO",
      description: "Asset GL Mentained In HO"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "",
      tab: "beginDay",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Auto Renewal at the Time of Bank Begin Day",
      name: "AutoRenewal_attheTimeof_BankBeginDay",
      description: "Auto Renewal at the Time of Bank Begin Day"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "",
      tab: "beginDay",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Auto Renewal at the Time of Branch Begin Day",
      name: "AutoRenewal_attheTimeof_BranchBeginDay",
      description: "Auto Renewal at the Time of Branch Begin Day"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "",
      tab: "beginDay",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Pending Charges Collect atthe Time of Branch Begin Day",
      name: "PendingChargesCollect_attheTimeof_BranchBeginDay",
      description: "Pending Charges Collect atthe Time of Branch Begin Day"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "",
      tab: "beginDay",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Auto Branch(s) Open at the Time of Bank Begin Day",
      name: "AutoBranchOpen_attheTimeof_BankBeginDay",
      description: "Auto Branch(s) Open at the Time of Bank Begin Day"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "",
      tab: "beginDay",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Auto User(s) Registration atthe Time of Branch Begin Day",
      name: "AutoUserRegistration_attheTimeof_BranchBeginDay",
      description: "Auto User(s) Registration at the Time of Branch Begin Day"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "",
      tab: "beginDay",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Standing Execution at the Time of Bank Begin Day",
      name: "StandingExecution _attheTimeof_BankBeginDay",
      description: "Standing Execution  Open at the Time of Bank Begin Day"
    },
    {
      inputType: "displaytext",
      tab: "beginDay",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Previous Open Date For Transaction",
      name: "",
      description: "Enter Previous Open Date For Transaction"
    },
    {
      inputType: "date",
      dateType: "ontype",
      tab: "beginDay",
      isRequired: true,
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Opening Date",
      displayFormat: "DD/MM/YYYY",
      outputFormat: "YYYYMMDD",
      name: "PreviousOpenDateFor_Transaction",
      description: "Enter Previous Open Date For Transaction"
    },

  ]
}

export default pr000;